import React from 'react';
import './LiveMonitor.css';

function LiveMonitor({ sessions, formatTime }) {
  if (sessions.length === 0) {
    return (
      <div className="live-monitor">
        <div className="empty-state">
          <h2>No Active Sessions</h2>
          <p>No candidates are currently taking assessments.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="live-monitor">
      <div className="monitor-header">
        <h2>Live Sessions</h2>
        <p className="monitor-subtitle">Real-time monitoring of active assessment sessions</p>
      </div>

      <div className="sessions-grid">
        {sessions.map((session) => {
          const timeElapsedPercent = session.metrics?.timeRemaining && session.metrics?.timeElapsed
            ? (session.metrics.timeElapsed / (session.metrics.timeElapsed + session.metrics.timeRemaining)) * 100
            : 0;

          return (
            <div key={session._id} className="session-card">
              {/* Card Header */}
              <div className="session-header">
                <div className="session-title">
                  <h3>{session.candidateId?.name || 'Unknown'}</h3>
                  <span className="assessment-name">{session.assessmentId?.name}</span>
                </div>
                <span className="status-indicator active">LIVE</span>
              </div>

              {/* Challenge Info */}
              <div className="challenge-info">
                <div className="info-row">
                  <span className="label">Challenge:</span>
                  <span className="value">{session.challengeId?.title || 'Loading...'}</span>
                </div>
                <div className="info-row">
                  <span className="label">Category:</span>
                  <span className="value">{session.challengeId?.category || 'N/A'}</span>
                </div>
                <div className="info-row">
                  <span className="label">Difficulty:</span>
                  <span className="value difficulty">{session.challengeId?.difficulty || 'N/A'}</span>
                </div>
              </div>

              {/* Metrics */}
              <div className="session-metrics">
                <div className="metric">
                  <div className="metric-value">{session.metrics?.flagSubmissions || 0}</div>
                  <div className="metric-label">Flag Attempts</div>
                </div>
                <div className="metric">
                  <div className="metric-value">{session.metrics?.flagsCorrect || 0}</div>
                  <div className="metric-label">Correct Flags</div>
                </div>
                <div className="metric">
                  <div className="metric-value">{session.metrics?.hintsUsed || 0}</div>
                  <div className="metric-label">Hints Used</div>
                </div>
                <div className="metric">
                  <div className="metric-value">{session.metrics?.hintsRemaining || 0}</div>
                  <div className="metric-label">Hints Left</div>
                </div>
              </div>

              {/* Time Progress */}
              {session.metrics?.timeRemaining !== null && (
                <div className="time-section">
                  <div className="time-info">
                    <span className="time-label">Time Elapsed:</span>
                    <span className="time-value">{formatTime(session.metrics.timeElapsed)}</span>
                  </div>
                  <div className="time-progress-bar">
                    <div
                      className="time-progress-fill"
                      style={{ width: `${timeElapsedPercent}%` }}
                    />
                  </div>
                  <div className="time-info">
                    <span className="time-label">Time Remaining:</span>
                    <span className={`time-value ${session.metrics.timeRemaining < 300 ? 'warning' : ''}`}>
                      {formatTime(session.metrics.timeRemaining)}
                    </span>
                  </div>
                </div>
              )}

              {/* Actions */}
              <div className="session-actions">
                <button className="btn btn-sm btn-secondary" title="View detailed logs">
                  View Logs
                </button>
                {session.hints?.pending && (
                  <button className="btn btn-sm btn-primary">
                    Approve Hint Request
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default LiveMonitor;
